module.exports = __webpack_public_path__ + "img/logout-icon.30bdc496.svg";